import {Component} from 'preact'
import {connect} from 'preact-redux'
import style from './style.scss'

class Button extends Component {
    constructor(props) {
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);

        this.state = {
            hover: false
        }
    }

    mouseEnter() {
        this.setState({hover: true});
        this.props.mouseEnter();
    }

    mouseLeave() {
        this.setState({hover: false});
        this.props.mouseLeave();
    }



    render() {
        const {text, color, onClick, active} = this.props
        const {hover} = this.state
        const bgColor = hover || active ? color : 'white';
        const textColor = hover || active ? 'white' : '#6c6c6c';
        const border = hover || active ?
            `solid 2px ${color}`
            : 'solid 2px #bababa';

        return (
            <div className={style.ButtonContainer}
                style={{
                    backgroundColor: bgColor,
                    border: border,
                    color: textColor
                }}
                onClick={onClick}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}>
                {text}
            </div>
        )
    }
 }

export default Button;



// WEBPACK FOOTER //
// ./routes/HelpDesk/HelpDeskArticle/Feedback/Button/index.js